<template>
    <ui-sidepage extra-large :close="refreshAndClose" :title="title" :subtitle="subtitle">
        <estimates-old-page-material-list
            class="mt-8"
            :context="context"
            :context-type="contextType"
        ></estimates-old-page-material-list>
    </ui-sidepage>
</template>

<script>
import { estimateStore } from '@stores'

export default {
    props: {
        materials: Array,
        context: Object,
        contextType: String,
        close: Function,
    },
    computed: {
        $store () {
            return estimateStore
        },
        title () {
            if (this.contextType === 'section') return this.context.title ?? 'Untitled section'
            if (this.contextType === 'task') return `${this.context.ref} • ${this.context.name ?? 'Untitled task'}`
            if (this.contextType === 'item') return `${this.context.ref} • ${this.context.description ?? 'Untitled item'}`
            return 'Material list for the estimate'
        },
        subtitle () {
            if (this.contextType === 'section') return 'Material list for the section.'
            if (this.contextType === 'task') return 'Material list for the task.'
            if (this.contextType === 'item') return 'Material list for the item.'
            return 'This include all materials from all sections.'
        },
    },
    methods: {
        refreshAndClose () {
            this.$store.refreshAndRecalculateLocalSpecs()
            this.close()
        },
    },
}
</script>
